if (!customElements.get('parfumeur-stack')) {
  customElements.define('parfumeur-stack', class ParfumeurStack extends HTMLElement {
    connectedCallback() {
      if (!window.matchMedia('(min-width: 1000px)').matches) return;

      this.items = Array.from(this.querySelectorAll('.parfumeur-item'));
      if (this.items.length < 2) return;

      // Donne à la section assez de hauteur pour que chaque block ait son propre budget de scroll
      this.style.height = `${this.items.length * 100}vh`;
      this.currentIndex = 0;

      this.handleScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    onScroll() {
      const rect = this.getBoundingClientRect();
      const scrolled = -rect.top;
      const totalBudget = this.offsetHeight - window.innerHeight;

      if (totalBudget <= 0) return;

      const progress = Math.max(0, Math.min(scrolled / totalBudget, 1));
      const targetIndex = Math.min(
        Math.floor(progress * this.items.length),
        this.items.length - 1
      );

      if (targetIndex === this.currentIndex) return;

      this.items[this.currentIndex].style.opacity = '0';
      this.items[this.currentIndex].style.pointerEvents = 'none';
      this.items[targetIndex].style.opacity = '1';
      this.items[targetIndex].style.pointerEvents = 'auto';
      this.currentIndex = targetIndex;
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  });
}
